/*/ ## EF.Collections.AnswersCollection
//
// Collection for the possible answers to survey questions. */
(function(EF, undefined) {

  var AnswersCollection = Backbone.Collection.extend({ });

  _.extend(EF.Collections, {
    AnswersCollection: AnswersCollection
  });

})(EF);
